var _defs, _path, _path2, _rect, _rect2, _rect3, _polygon, _path3, _rect4, _path4, _path5, _path6, _path7, _path8, _path9, _line, _line2, _path10, _path11, _ellipse, _path12, _path13, _polygon2, _rect5, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 207.33 165.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5badff;}.b{fill:#dcedfc;}.b,.d,.l{opacity:0.2;}.c{fill:#fff;}.d,.g,.l{fill:#114374;}.e{fill:#0083e8;}.f,.j{fill:#1df3ce;}.f,.l{fill-rule:evenodd;}.h,.k,.m{fill:none;}.h,.m{stroke:#5badff;stroke-linecap:round;stroke-linejoin:round;}.i{fill:#2b6eae;}.k{stroke:#0083e8;stroke-miterlimit:10;}.m{stroke-width:0.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "register") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1896.23,3301.22H1761.5c-10.86,0-26,17.07-26,40.34v15.32a6.75,6.75,0,0,0,6.75,6.75H1877Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1742.5,3341.62h0.25a6.91,6.91,0,0,1-6.81-5c-0.12,1.46-.44,3.09-0.44,4.6v15.32a7.52,7.52,0,0,0,7.25,7.13H1877.5l6.58-22H1742.5Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 33,
    y: 100,
    width: 82,
    height: 27
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 33,
    y: 100,
    width: 82,
    height: 3.37
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 33,
    y: 71,
    width: 82,
    height: 20
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "58.27 138.94 53.23 137.08 48.2 138.94 48.2 123.82 58.27 123.82 58.27 138.94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1857.5,3318.62a4,4,0,0,1-4,4h-88a4,4,0,0,1-4-4h0a4,4,0,0,1,4-4h88a4,4,0,0,1,4,4h0Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 33,
    width: 82,
    height: 59
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1785.86,3277.22h0.92l2.79,8.16h0l2.8-8.16h0.87l-3.28,9.38h-0.85Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1794.47,3281.89c0-2.93,1.65-4.85,3.94-4.85s3.94,1.92,3.94,4.85-1.65,4.85-3.94,4.85S1794.47,3284.82,1794.47,3281.89Zm7,0c0-2.54-1.27-4-3-4s-3,1.49-3,4,1.27,4,3,4S1801.45,3284.43,1801.45,3281.89Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1804.3,3277.22h1l5.15,7.7h0v-7.7h0.85v9.34h-0.79l-5.31-7.94h0v7.94h-0.85v-9.34Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1813.68,3277.22h1l5.15,7.7h0v-7.7h0.85v9.34h-0.79l-5.32-7.94h0v7.94h-0.85v-9.34Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1823.19,3277.22h0.89v9.34h-0.89v-9.34Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1826.15,3284.27l0.8-.29a2.63,2.63,0,0,0,2.68,2c1.4,0,2.31-.64,2.31-1.69s-0.47-1.46-2.45-2.1-3-1.17-3-2.71c0-1.34,1.2-2.4,2.9-2.4a3.12,3.12,0,0,1,3.21,2.15l-0.76.35a2.39,2.39,0,0,0-2.46-1.69c-1.25,0-2,.67-2,1.53,0,1,.62,1.4,2.59,2s2.9,1.26,2.9,2.78-1.38,2.55-3.24,2.55A3.36,3.36,0,0,1,1826.15,3284.27Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 44.5,
    y1: 35,
    x2: 103.5,
    y2: 35
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 44.5,
    y1: 44,
    x2: 103.5,
    y2: 44
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1877.17,3363.62h21.33a7,7,0,0,0,7-7V3325c0-17-3.16-23.78-9-23.78-10.86,0-26.25,16.46-26.25,39.73v16.18a6.5,6.5,0,0,0,6.5,6.5h0.42Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1894,3346.62h-6c-0.91,0-1.66,1.79-1.66,4s0.74,4,1.66,4h6v-8Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 158.5,
    cy: 87,
    rx: 1.66,
    ry: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1892.34,3350.62h34.49a15.5,15.5,0,0,1,0,31h-34.69a13.5,13.5,0,0,0,0,27h10a9.85,9.85,0,0,1,9.86,9.86v10.46",
    transform: "translate(-1735.5 -3263.62)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1797,3384.41l3.41-3.41-3.41-3.41v-4.83h-4.83l-3.41-3.41-3.41,3.41h-4.83v4.83l-3.41,3.41,3.41,3.41v4.83h4.83l3.41,3.41,3.41-3.41H1797v-4.83Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "l",
    points: "48.2 125.62 48.2 127.97 49.82 127.97 53.23 131.38 56.65 127.97 58.27 127.97 58.27 125.62 56.65 125.62 53.23 129.03 49.82 125.62 48.2 125.62"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 33,
    y: 55.63,
    width: 82,
    height: 3.37
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1811,3381.63c2.26-.05,4.17-2.24,5.6-3.75,0.86-.91,3.22-2.91,3-4.35-2.22,3.79-3.31,8.19-5.28,12.12,5.3,1.32,7.76-10.9,2.91-10.91-2.54,0-4.37,3.63-2.27,5.36,2.42,2,7.21.22,9.22-1.62,1.76-1.61.46-2.28-.77-0.67a2.7,2.7,0,0,0,1.31,4.34c1.54,0.58,2.76-.11,4.26-0.17a7.55,7.55,0,0,1,3.53,1.16",
    transform: "translate(-1735.5 -3263.62)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1775,3341.39h2.59c1.73,0,2.69.73,2.69,2.09a2,2,0,0,1-1.85,2.09l2,3.55h-0.84l-1.89-3.47h-1.92v3.47H1775v-7.74Zm2.54,3.61c1.27,0,2-.37,2-1.48s-0.71-1.44-2-1.44h-1.8V3345h1.81Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1782,3341.39h4.62v0.69h-3.88v2.62h2.9v0.67h-2.9v3.07h4.1v0.68H1782v-7.74Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1788,3345.22c0-2.44,1.36-4,3.23-4a2.76,2.76,0,0,1,2.81,2.37l-0.71.17c-0.37-1.28-1-1.86-2.11-1.86-1.34,0-2.48,1.1-2.48,3.27s1,3.41,2.5,3.41c1.3,0,2.15-.91,2.14-2.48h-1.87v-0.64h2.59v3.64h-0.67v-1.18h0a2.35,2.35,0,0,1-2.24,1.33C1789.13,3349.27,1788,3347.55,1788,3345.22Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1796,3341.39h0.74v7.74H1796v-7.74Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1798.47,3347.22l0.66-.24a2.18,2.18,0,0,0,2.22,1.63c1.16,0,1.91-.53,1.91-1.4s-0.39-1.21-2-1.74-2.51-1-2.51-2.25a2.17,2.17,0,0,1,2.4-2,2.59,2.59,0,0,1,2.66,1.78l-0.63.29a2,2,0,0,0-2-1.4,1.43,1.43,0,0,0-1.66,1.26c0,0.87.51,1.16,2.14,1.68s2.4,1,2.4,2.3-1.14,2.11-2.69,2.11A2.78,2.78,0,0,1,1798.47,3347.22Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1807.51,3342.08H1805v-0.69h5.74v0.69h-2.5v7h-0.74v-7Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1812.1,3341.39h2.59c1.73,0,2.69.73,2.69,2.09a2,2,0,0,1-1.85,2.09l2,3.55h-0.84l-1.89-3.47h-1.92v3.47h-0.73v-7.74Zm2.54,3.61c1.28,0,2-.37,2-1.48s-0.71-1.44-2-1.44h-1.8V3345h1.81Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1819.12,3341.39h4.62v0.69h-3.88v2.62h2.9v0.67h-2.9v3.07h4.1v0.68h-4.84v-7.74Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1825.44,3341.39H1828c1.73,0,2.69.73,2.69,2.09a2,2,0,0,1-1.85,2.09l2,3.55H1830l-1.89-3.47h-1.92v3.47h-0.73v-7.74ZM1828,3345c1.28,0,2-.37,2-1.48s-0.71-1.44-2-1.44h-1.8V3345H1828Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1832.45,3341.39h4.62v0.69h-3.88v2.62h2.9v0.67h-2.9v3.07h4.1v0.68h-4.84v-7.74Z",
    transform: "translate(-1735.5 -3263.62)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1838.77,3341.39h0.79l4.27,6.38h0v-6.38h0.7v7.74h-0.66l-4.4-6.58h0v6.58h-0.7v-7.74Z",
    transform: "translate(-1735.5 -3263.62)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.5eb1e51c2ea38af2088cea0e3a3f84dd.svg";
export { ForwardRef as ReactComponent };